export enum OperationType {
  PayIn = "RECHARGE",
  PayOut = "DEBIT",
}

export enum TransactionMethod {
  BankTransfer,
  Wallet,
}
